import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { LogOut as LogoutRoundedIcon, Bell as NotificationsRoundedIcon } from 'lucide-react';
import MenuButton from '../Header/MenuButton';
import MenuContent from './MenuContent';

interface SideMenuMobileProps {
  open: boolean | undefined;
  toggleDrawer: (newOpen: boolean) => () => void;
  user: {
    name: string;
    email: string;
    avatar?: string;
  };
  currentView: string;
  onViewChange: (view: string) => void;
  onLogout: () => void;
}

export default function SideMenuMobile({ open, toggleDrawer, user, currentView, onViewChange, onLogout }: SideMenuMobileProps) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => toggleDrawer(false)}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        [`& .${drawerClasses.paper}`]: {
          backgroundImage: 'none',
          backgroundColor: '#0f0f0f',
          color: '#ffffff',
        },
      }}
    >
      <Stack
        sx={{
          maxWidth: '70dvw',
          height: '100%',
          backgroundColor: '#0f0f0f',
        }}
      >
        <Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
          <Stack
            direction="row"
            sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}
          >
            <Avatar
              sizes="small"
              alt={user.name}
              src={user.avatar}
              sx={{ width: 24, height: 24, bgcolor: 'hsl(45, 90%, 35%)' }}
            />
            <Typography component="p" variant="h6" sx={{ fontSize: '1rem', color: '#ffffff' }}>
              {user.name}
            </Typography>
          </Stack>
          <MenuButton showBadge sx={{ color: '#ffffff' }}>
            <NotificationsRoundedIcon size={20} />
          </MenuButton>
        </Stack>
        <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)' }} />
        <Stack sx={{ flexGrow: 1 }}>
          <MenuContent currentView={currentView} onViewChange={(view) => {
            onViewChange(view);
            toggleDrawer(false);
          }} />
          <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.1)' }} />
        </Stack>
        <Stack sx={{ p: 2 }}>
          <Button 
            variant="outlined" 
            fullWidth 
            startIcon={<LogoutRoundedIcon size={18} />}
            onClick={onLogout}
            sx={{ 
              color: '#ffffff', 
              borderColor: 'rgba(255, 255, 255, 0.3)',
              '&:hover': {
                borderColor: '#ffffff',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
              }
            }}
          >
            Logout
          </Button>
        </Stack>
      </Stack>
    </Drawer>
  );
}
